import {MethodCategoriesEnum, StringResult, StringTemplateMethod, UrlResult} from './internal';

export class GetQueryParamMethod extends StringTemplateMethod {
  constructor() {
    super(MethodCategoriesEnum.EXTRACT, StringResult, 'name');
  }
}

export class UrlConverter extends StringTemplateMethod {
  constructor() {
    super(MethodCategoriesEnum.PARSE, UrlResult, 'url', true);
  }
}
